// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"incomplete-profile-mobile-content_component_wrapper__1XDka","companyLogoWrapper":"incomplete-profile-mobile-content_component_companyLogoWrapper__wng9K"};